import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    const lng = parseFloat(this.element.getAttribute("data-lng"));
    const lat = parseFloat(this.element.getAttribute("data-lat"));

    mapboxgl.accessToken = 'pk.eyJ1IjoiYWRhbWFhYyIsImEiOiJjbHUwMjJhaHQwNndrMmtrMW1uYnlqMXptIn0.jTypopzA8IvvAW0TsqSdrw';

      // Define initial coordinates
      var coords = [lng, lat];

      // Create a new map instance
      var map = new mapboxgl.Map({
        container: 'map', // Specify the container ID
        style: 'mapbox://styles/mapbox/streets-v11', // Specify the style URL
        center: coords, // Specify the starting position [lng, lat]
        zoom: 14 // Specify the starting zoom level
      });

      // Add a marker to the map
      new mapboxgl.Marker()
        .setLngLat(coords)
        .addTo(map);
  }

  disconnect() {

  }
}